(function() {
  'use strict';

  angular.module('blocks.display', []);

})();
